const ArgumentType = require('../extension-support/argument-type');
const BlockType = require('../extension-support/block-type');
const Cast = require('../util/cast');
const log = require('../util/log');

class Scratch3ApiConnector {
    constructor(runtime) {
        this.runtime = runtime;
        this._baseUrl = '';
        this._headers = {};
        this._apiKey = '';
        this._lastResponse = '';
        this._lastStatus = 0;
        this._lastError = '';
        this._proxyUrl = '';
        this._useProxy = false;
    }

    getInfo() {
        return {
            id: 'apiConnector',
            name: 'API Connector',
            color1: '#6366F1',
            color2: '#4F46E5',
            color3: '#4338CA',
            menuIconURI: this._getMenuIcon(),
            blockIconURI: this._getBlockIcon(),
            blocks: [
                {
                    opcode: 'setBaseUrl',
                    blockType: BlockType.COMMAND,
                    text: '🔗 ベースURL [URL] を設定',
                    arguments: { URL: { type: ArgumentType.STRING, defaultValue: 'https://api.example.com' } }
                },
                {
                    opcode: 'setHeader',
                    blockType: BlockType.COMMAND,
                    text: '📝 ヘッダー [KEY] を [VALUE] に設定',
                    arguments: {
                        KEY: { type: ArgumentType.STRING, defaultValue: 'Content-Type' },
                        VALUE: { type: ArgumentType.STRING, defaultValue: 'application/json' }
                    }
                },
                {
                    opcode: 'setApiKey',
                    blockType: BlockType.COMMAND,
                    text: '🔑 APIキー [KEY] を設定',
                    arguments: { KEY: { type: ArgumentType.STRING, defaultValue: '' } }
                },
                {
                    opcode: 'setProxyUrl',
                    blockType: BlockType.COMMAND,
                    text: '🔄 プロキシURL [URL] を設定',
                    arguments: { URL: { type: ArgumentType.STRING, defaultValue: '' } }
                },
                { opcode: 'clearHeaders', blockType: BlockType.COMMAND, text: '🗑️ ヘッダーをクリア' },
                '---',
                {
                    opcode: 'getRequest',
                    blockType: BlockType.COMMAND,
                    text: '🌐 GET [URL]',
                    arguments: { URL: { type: ArgumentType.STRING, defaultValue: '/endpoint' } }
                },
                {
                    opcode: 'postRequest',
                    blockType: BlockType.COMMAND,
                    text: '📤 POST [URL] データ [DATA]',
                    arguments: {
                        URL: { type: ArgumentType.STRING, defaultValue: '/endpoint' },
                        DATA: { type: ArgumentType.STRING, defaultValue: '{"key":"value"}' }
                    }
                },
                {
                    opcode: 'putRequest',
                    blockType: BlockType.COMMAND,
                    text: '📝 PUT [URL] データ [DATA]',
                    arguments: {
                        URL: { type: ArgumentType.STRING, defaultValue: '/endpoint' },
                        DATA: { type: ArgumentType.STRING, defaultValue: '{"key":"value"}' }
                    }
                },
                {
                    opcode: 'deleteRequest',
                    blockType: BlockType.COMMAND,
                    text: '🗑️ DELETE [URL]',
                    arguments: { URL: { type: ArgumentType.STRING, defaultValue: '/endpoint' } }
                },
                '---',
                { opcode: 'getResponse', blockType: BlockType.REPORTER, text: '📥 レスポンス' },
                { opcode: 'getStatus', blockType: BlockType.REPORTER, text: '📊 ステータスコード' },
                { opcode: 'getError', blockType: BlockType.REPORTER, text: '⚠️ エラー' },
                {
                    opcode: 'parseJson',
                    blockType: BlockType.REPORTER,
                    text: '🔍 JSON [KEY] を取得',
                    arguments: { KEY: { type: ArgumentType.STRING, defaultValue: 'joke' } }
                },
                { opcode: 'isSuccess', blockType: BlockType.BOOLEAN, text: '✅ 成功？' },
                '---',
                {
                    opcode: 'presetWeather',
                    blockType: BlockType.COMMAND,
                    text: '🌤️ 天気取得 [CITY] APIキー [KEY]',
                    arguments: {
                        CITY: { type: ArgumentType.STRING, defaultValue: 'Tokyo' },
                        KEY: { type: ArgumentType.STRING, defaultValue: '' }
                    }
                },
                { opcode: 'presetRandomCat', blockType: BlockType.COMMAND, text: '🐱 ランダム猫画像を取得' },
                { opcode: 'presetRandomDog', blockType: BlockType.COMMAND, text: '🐶 ランダム犬画像を取得' },
                { opcode: 'presetJoke', blockType: BlockType.COMMAND, text: '😂 ジョークを取得' },
                '---',
                {
                    opcode: 'createJson',
                    blockType: BlockType.REPORTER,
                    text: '📦 JSON [KEY1]:[VAL1] [KEY2]:[VAL2]',
                    arguments: {
                        KEY1: { type: ArgumentType.STRING, defaultValue: 'name' },
                        VAL1: { type: ArgumentType.STRING, defaultValue: 'Scratch' },
                        KEY2: { type: ArgumentType.STRING, defaultValue: 'ver' },
                        VAL2: { type: ArgumentType.STRING, defaultValue: '3' }
                    }
                },
                {
                    opcode: 'encodeUrl',
                    blockType: BlockType.REPORTER,
                    text: '🔗 URLエンコード [TEXT]',
                    arguments: { TEXT: { type: ArgumentType.STRING, defaultValue: 'hello world' } }
                }
            ]
        };
    }

    _getMenuIcon() {
        return 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0MCA0MCI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJhcGlHcmFkIiB4MT0iMCUiIHkxPSIwJSIgeDI9IjEwMCUiIHkyPSIxMDAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNjM2NkYxIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojNEY0NkU1Ii8+PC9saW5lYXJHcmFkaWVudD48L2RlZnM+PGNpcmNsZSBjeD0iMjAiIGN5PSIyMCIgcj0iMTgiIGZpbGw9InVybCgjYXBpR3JhZCkiLz48cGF0aCBkPSJNMTAgMjBoMjBNMjAgMTB2MjAiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMi41IiBzdHJva2UtbGluZWNhcD0icm91bmQiLz48Y2lyY2xlIGN4PSIyMCIgY3k9IjIwIiByPSI1IiBmaWxsPSJ3aGl0ZSIvPjxjaXJjbGUgY3g9IjEwIiBjeT0iMjAiIHI9IjIuNSIgZmlsbD0id2hpdGUiIG9wYWNpdHk9IjAuNyIvPjxjaXJjbGUgY3g9IjMwIiBjeT0iMjAiIHI9IjIuNSIgZmlsbD0id2hpdGUiIG9wYWNpdHk9IjAuNyIvPjxjaXJjbGUgY3g9IjIwIiBjeT0iMTAiIHI9IjIuNSIgZmlsbD0id2hpdGUiIG9wYWNpdHk9IjAuNyIvPjxjaXJjbGUgY3g9IjIwIiBjeT0iMzAiIHI9IjIuNSIgZmlsbD0id2hpdGUiIG9wYWNpdHk9IjAuNyIvPjwvc3ZnPg==';
    }

    _getBlockIcon() { return this._getMenuIcon(); }

    setBaseUrl(args) { this._baseUrl = Cast.toString(args.URL).trim(); }
    
    setHeader(args) {
        var key = Cast.toString(args.KEY).trim();
        if (key) this._headers[key] = Cast.toString(args.VALUE);
    }
    
    setApiKey(args) {
        this._apiKey = Cast.toString(args.KEY);
        if (this._apiKey) this._headers['Authorization'] = 'Bearer ' + this._apiKey;
    }
    
    setProxyUrl(args) {
        this._proxyUrl = Cast.toString(args.URL).trim();
        this._useProxy = this._proxyUrl.length > 0;
    }
    
    clearHeaders() { this._headers = {}; this._apiKey = ''; }

    _makeRequest(url, method, body) {
        var self = this;
        return new Promise(function(resolve) {
            var fullUrl = url.indexOf('http') === 0 ? url : self._baseUrl + url;
            if (self._useProxy && self._proxyUrl) {
                fullUrl = self._proxyUrl + '?url=' + encodeURIComponent(fullUrl);
            }
            var headers = {};
            for (var key in self._headers) {
                headers[key] = self._headers[key];
            }
            var options = { method: method, headers: headers };
            if (body && (method === 'POST' || method === 'PUT')) {
                options.body = body;
                if (!options.headers['Content-Type']) {
                    options.headers['Content-Type'] = 'application/json';
                }
            }
            fetch(fullUrl, options)
                .then(function(response) {
                    self._lastStatus = response.status;
                    return response.text();
                })
                .then(function(text) {
                    self._lastResponse = text;
                    self._lastError = '';
                    log.log('API Connector: Response received, status=' + self._lastStatus);
                    resolve();
                })
                .catch(function(error) {
                    self._lastError = error.message;
                    self._lastStatus = 0;
                    self._lastResponse = '';
                    log.warn('API Connector: Error - ' + error.message);
                    resolve();
                });
        });
    }

    getRequest(args) { return this._makeRequest(Cast.toString(args.URL), 'GET', null); }
    postRequest(args) { return this._makeRequest(Cast.toString(args.URL), 'POST', Cast.toString(args.DATA)); }
    putRequest(args) { return this._makeRequest(Cast.toString(args.URL), 'PUT', Cast.toString(args.DATA)); }
    deleteRequest(args) { return this._makeRequest(Cast.toString(args.URL), 'DELETE', null); }
    
    getResponse() { return this._lastResponse; }
    getStatus() { return this._lastStatus; }
    getError() { return this._lastError; }
    
    // 修正版 parseJson！！
    parseJson(args) {
        var keyPath = Cast.toString(args.KEY).trim();
        var response = this._lastResponse;
        
        log.log('API Connector parseJson: key=' + keyPath + ', response length=' + response.length);
        
        // レスポンスが空なら空文字を返す
        if (!response || response.length === 0) {
            log.warn('API Connector parseJson: Empty response');
            return '';
        }
        
        // JSONをパース
        var data;
        try {
            data = JSON.parse(response);
            log.log('API Connector parseJson: JSON parsed successfully');
        } catch (e) {
            log.warn('API Connector parseJson: JSON parse error - ' + e.message);
            return '';
        }
        
        // キーが空なら全体を返す
        if (!keyPath || keyPath.length === 0) {
            return response;
        }
        
        // ドットで分割してネストされたキーにアクセス
        var keys = keyPath.split('.');
        var result = data;
        
        for (var i = 0; i < keys.length; i++) {
            var key = keys[i];
            
            if (result === null || result === undefined) {
                log.warn('API Connector parseJson: null/undefined at key ' + key);
                return '';
            }
            
            if (typeof result !== 'object') {
                log.warn('API Connector parseJson: not an object at key ' + key);
                return '';
            }
            
            // 配列のインデックスアクセス
            if (Array.isArray(result)) {
                var index = parseInt(key, 10);
                if (isNaN(index)) {
                    log.warn('API Connector parseJson: invalid array index ' + key);
                    return '';
                }
                result = result[index];
            } else {
                // オブジェクトのキーアクセス
                result = result[key];
            }
            
            log.log('API Connector parseJson: key=' + key + ', result type=' + typeof result);
        }
        
        // 結果を返す
        if (result === null || result === undefined) {
            return '';
        }
        
        if (typeof result === 'object') {
            return JSON.stringify(result);
        }
        
        return String(result);
    }
    
    isSuccess() { return this._lastStatus >= 200 && this._lastStatus < 300; }
    
    presetWeather(args) {
        var city = Cast.toString(args.CITY);
        var key = Cast.toString(args.KEY);
        var url = 'https://api.openweathermap.org/data/2.5/weather?q=' + encodeURIComponent(city) + '&appid=' + key + '&units=metric&lang=ja';
        return this._makeRequest(url, 'GET', null);
    }
    
    presetRandomCat() { return this._makeRequest('https://api.thecatapi.com/v1/images/search', 'GET', null); }
    presetRandomDog() { return this._makeRequest('https://dog.ceo/api/breeds/image/random', 'GET', null); }
    presetJoke() { return this._makeRequest('https://v2.jokeapi.dev/joke/Any?safe-mode', 'GET', null); }
    
    createJson(args) {
        var obj = {};
        var k1 = Cast.toString(args.KEY1);
        var k2 = Cast.toString(args.KEY2);
        if (k1) obj[k1] = Cast.toString(args.VAL1);
        if (k2) obj[k2] = Cast.toString(args.VAL2);
        return JSON.stringify(obj);
    }
    
    encodeUrl(args) { return encodeURIComponent(Cast.toString(args.TEXT)); }
}

module.exports = Scratch3ApiConnector;
